import { render, staticRenderFns } from "./SchoolSplitHelpers.vue?vue&type=template&id=7da3c1b4&scoped=true&"
import script from "./SchoolSplitHelpers.vue?vue&type=script&lang=js&"
export * from "./SchoolSplitHelpers.vue?vue&type=script&lang=js&"
import style0 from "./SchoolSplitHelpers.vue?vue&type=style&index=0&id=7da3c1b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da3c1b4",
  null
  
)

export default component.exports